import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-live"];
export default {
  __name: 'FieldFeedback',
  props: {
    message: {
      type: String,
      default: ''
    },
    tone: {
      type: String,
      default: 'error',
      validator: v => ['error', 'warning', 'success', 'info'].includes(v)
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.message ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: _normalizeClass(["ds-field-feedback", `ds-field-feedback--${__props.tone}`]),
        role: "alert",
        "aria-live": __props.tone === 'error' ? 'assertive' : 'polite'
      }, _toDisplayString(__props.message), 11, _hoisted_1)) : _createCommentVNode("", true);
    };
  }
};